<script>
import PageHeader from '../../SettingsSubPageHeader.vue';
import BandwidthSms from './BandwidthSms.vue';
import Twilio from './Twilio.vue';

export default {
  components: {
    PageHeader,
    Twilio,
    BandwidthSms,
  },
  props: {
    type: {
      type: String,
      default: 'sms',
    },
  },
  data() {
    return {
      provider: this.type === 'whatsapp' ? '' : 'twilio',
      twilioMedium: this.type || 'sms',
    };
  },
  watch: {
    provider(newVal) {
      if (newVal === 'twilio-whatsapp') {
        this.twilioMedium = 'whatsapp';
      } else if (newVal === 'twilio') {
        this.twilioMedium = 'sms';
      }
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <PageHeader
      :header-title="
        type === 'whatsapp'
          ? $t('INBOX_MGMT.ADD.TWILIO_WHATSAPP.TITLE')
          : $t('INBOX_MGMT.ADD.SMS.TITLE')
      "
      :header-content="
        type === 'whatsapp'
          ? $t('INBOX_MGMT.ADD.TWILIO_WHATSAPP.DESC')
          : $t('INBOX_MGMT.ADD.SMS.DESC')
      "
    />
    <div
      v-if="type !== 'whatsapp'"
      class="flex-shrink-0 flex-grow-0"
    >
      <label>
        {{ $t('INBOX_MGMT.ADD.SMS.PROVIDERS.LABEL') }}
        <select v-model="provider">
          <option value="twilio">
            {{ $t('INBOX_MGMT.ADD.SMS.PROVIDERS.TWILIO') }}
          </option>
          <option value="twilio-whatsapp">
            {{ $t('INBOX_MGMT.ADD.TWILIO_WHATSAPP.TITLE') }}
          </option>
          <option value="360dialog">
            {{ $t('INBOX_MGMT.ADD.SMS.PROVIDERS.BANDWIDTH') }}
          </option>
        </select>
      </label>
    </div>
    <Twilio
      v-if="provider === 'twilio' || provider === 'twilio-whatsapp' || type === 'whatsapp'"
      :type="twilioMedium"
    />
    <BandwidthSms v-else-if="provider === '360dialog'" />
  </div>
</template>
